export default "__VITE_ASSET__BewZLQ98__"